import React from 'react'

import Image from 'next/image'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Column, Text } from 'Components/UI'

import { EXPERTISE_ITEMS } from './constants'
import { Card, Container, ImageHolder } from './styles'

type Props = PaddingProps

// Cards sit in a 1/2/3-column grid (40px gap) inside the 1440px content
// column, which carries 40px inline padding from the `md` breakpoint up.
const CARD_ILLUSTRATION_SIZES =
  '(min-width: 1520px) 453px, (min-width: 992px) calc((100vw - 160px) / 3), (min-width: 575px) calc((100vw - 120px) / 2), 100vw'

function FastToMarketSection({ ...rest }: Props) {
  return (
    <SectionWrapper {...rest}>
      <Column>
        {/* /expertise page h1 (this section opens the page) */}
        <Text as="h1" mb={5} medium title title40>
          Fast to Market. Ready to Grow.
        </Text>

        <Text body body16 maxWidth={640} semiLight>
          We craft startup-ready solution — driven by strategy, accelerated by
          AI, and ready to deploy fast with minimal tech debt.
        </Text>

        <Container
          gridTemplateColumns={[
            '1fr',
            '1fr',
            'repeat(2, 1fr)',
            'repeat(2, 1fr)',
            'repeat(3, 1fr)',
          ]}
        >
          {EXPERTISE_ITEMS.map((item, index) => (
            <Card key={item.id}>
              <ImageHolder>
                <Image
                  alt={`Abstract picture of ${item.title}`}
                  // First card is the LCP element on /expertise; lazy-loading
                  // it cost 5 s of load delay on throttled mobile.
                  priority={index === 0}
                  sizes={CARD_ILLUSTRATION_SIZES}
                  src={item.illustration}
                />
              </ImageHolder>

              <Text as="h3" mb={5} medium mt={7} title title28>
                {item.title}
              </Text>

              <Text body body16 semiLight>
                {item.description}
              </Text>
            </Card>
          ))}
        </Container>
      </Column>
    </SectionWrapper>
  )
}

export default FastToMarketSection
